var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blade"},[_c('modal',{attrs:{"name":_vm.name,"title":_vm.title,"canClose":_vm.canClose}},[_vm._t("default"),_vm._v(" "),_c('template',{slot:"close"},[_c('icon',{attrs:{"icon":"x-small"}})],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }